import React from "react";
import { useTheme } from "@mui/styles";
import { Box, Typography } from "@mui/material";
import useTranslation from "../../hooks/useTranslation";
import { useLocation } from "react-router-dom";

const useStyles = (theme) => ({
  summary: {
    display: "flex",
    flexDirection: { xs: "column" },
    mt: { xs: "60px" },
    mb: { xs: "10rem" },
  },
  summaryChild: {
    width: "300px",
    display: "flex",
    alignItems: "center",
  },
  greenCheck: {
    height: "21px",
    width: "21px",
  },
  topics: {
    fontSize: { xs: "24px" },
    lineHeight: { xs: "55px" },
    fontFamily: theme.typography.anaHeim.regular,
    color: theme.palette.white.main,
    ml: { xs: "9px" },
  },
});

const TopicsMobile = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { pathname } = useLocation();
  const { topics, greenCheck } = useTranslation(pathname, "TopicsMobile");

  return (
    <Box sx={classes.summary}>
      {topics.map((topic) => {
        return (
          <Box sx={classes.summaryChild} key={topic}>
            <img
              src={greenCheck.src}
              alt={greenCheck.alt}
              style={classes.greenCheck}
            />
            <Typography sx={classes.topics}>{topic}</Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default TopicsMobile;
